import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n/config';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import Home from './pages/Home';
import NotreHistoire from './pages/NotreHistoire';
import NotreEquipe from './pages/NotreEquipe';
import NosActions from './pages/NosActions';
import ReglesDeVie from './pages/ReglesDeVie';
import RenseignementsPratiques from './pages/RenseignementsPratiques';
import Partenaires from './pages/Partenaires';
import Actualites from './pages/Actualites';
import Article from './pages/Article';
import Donations from './pages/Donations';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import ArticleList from './pages/admin/ArticleList';
import ArticleEditor from './pages/admin/ArticleEditor';
import ImageManager from './pages/admin/ImageManager';
import SiteContentEditor from './pages/admin/SiteContentEditor';
import './App.css';

function AppContent() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
    const isRTL = rtlLanguages.includes(i18n.language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <ProtectedRoute><AdminLayout /></ProtectedRoute>
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="articles" element={<ArticleList />} />
          <Route path="articles/new" element={<ArticleEditor />} />
          <Route path="articles/:id/edit" element={<ArticleEditor />} />
          <Route path="images" element={<ImageManager />} />
          <Route path="site-content" element={<SiteContentEditor />} />
        </Route>
      </Routes>
    );
  }

  return (
    <div id="page" className="hfeed site">
      <Header />

        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/notre-histoire" element={<NotreHistoire />} />
                <Route path="/notre-equipe" element={<NotreEquipe />} />
                <Route path="/nos-actions" element={<NosActions />} />
                <Route path="/regles-de-vie" element={<ReglesDeVie />} />
                <Route path="/renseignements-pratiques" element={<RenseignementsPratiques />} />
                <Route path="/partenaires" element={<Partenaires />} />
                <Route path="/actualites" element={<Actualites />} />
                <Route path="/actualites/:slug" element={<Article />} />
                <Route path="/donations" element={<Donations />} />
              </Routes>
            </main>
          </div>
        </div>

      <Footer />
      <Chatbot />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
